module.exports = __webpack_public_path__ + "img/denizaltı.64320e93.png";